<template>
    <div>
        <div class="d-flex justify-content-between align-items-center row">
            <div class="col-sm-12 col-md-1">
                <select style="width:60px !important" class="form-control" v-model="tableData.length" @change="changePerPage()">
                    <option v-for="(records, index) in perPage" :key="index" :value="records">{{records}}</option>
                </select>
            </div>
            <div class="mb-2 col-md-3 text-right">
                <input class="form-control" type="text" v-model="tableData.search"
                   @input="getSearch()">
            </div>
        </div>
        <v-table :columns="columns" :sortKey="sortKey" :sortOrders="sortOrders" @sort="sortBy">
            <tbody>
                <tr class="pointer" @click="showDetail(suggestion.uuid)" v-for="suggestion in suggestions" :key="suggestion.id">
                    <td>{{suggestion.customer}}</td>
                    <td>{{suggestion.email}}</td>
                    <td>{{suggestion.created_at}}</td>
                    <td>{{suggestion.product}}</td>
                </tr>
            </tbody>
        </v-table>
        <v-paginate :links="links" :navigationFunction="navigation"/>
    </div>
</template>

<script>
import {api, _buildQuery } from "../../../../helpers/shared";
import vTable from '../../../../components/vTable/vTable.vue';
import vPaginate from '../../../../components/vTable/vPaginate1.vue'
import axios from 'axios';
import  debounce  from 'lodash/debounce'
export default {
    components:{
        vTable, vPaginate
    },
    mounted(){
        this.getSuggestions()
    },
    data() {
        let sortOrders = {};
        let columns = [
            {width: '33%', label: 'Client', name: 'customer' },
            {width: '33%', label: 'Email', name: 'email'},
            {width: '33%', label: 'Date soumission', name: 'created_at'},
            {width: '33%', label: 'Produit concerné', name: 'product'}
        ];
        columns.forEach((column) => {
           sortOrders[column.name] = -1;
        });
        return {
            links: [],
            suggestions: [],
            columns: columns,
            sortKey: 'customer',
            sortOrders: sortOrders,
            perPage: ['10', '20', '30'],
            tableData: {
                page: 0,
                length: 10,
                search: '',
                column: 0,
                dir: 'desc',
                product: '',
                archived: 'cu'
            },
        }
    },
    methods: {
        showDetail(uuid){
            this.$router('/administration/suggestions/show/'+uuid)
        },
        getWithProduct(val){
            this.tableData.product = val;
            this.changePerPage();
        },
        changePerPage(url = 'administration/suggestions'){
            this.tableData.page = 1;
            axios.get(api(url), {params: this.tableData})
            .then(response => {
                let content = response.data;
                this.suggestions = content.data;
                this.configPagination(content);
            })
            .catch(errors => {
                console.log(errors);
            });
        },
        getNext(url){
            this.tableData.page ++;
            axios.get(url, {params: this.tableData})
            .then(response => {
                let content = response.data;
                this.suggestions = content.data;
                this.configPagination(content);
            })
            .catch(errors => {
                console.log(errors);
            });
        },
        getPrev(url){
            this.tableData.page --;
            axios.get(url, {params: this.tableData})
            .then(response => {
                let content = response.data;
                this.suggestions = content.data;
                this.configPagination(content);
            })
            .catch(errors => {
                console.log(errors);
            });
        },
        getSuggestions(url = 'administration/suggestions') {
            this.tableData.page++;
            axios.get(api(url), {params: this.tableData})
                .then(response => {
                    let content = response.data;
                    this.suggestions = content.data;
                    this.configPagination(content);
                })
                .catch(errors => {
                    console.log(errors);
                });
        },
        configPagination(data) {
            this.links = data.links;
        },
        sortBy(key) {
            this.sortKey = key;
            this.sortOrders[key] = this.sortOrders[key] * -1;
            this.tableData.column = this.getIndex(this.columns, 'name', key);
            this.tableData.dir = this.sortOrders[key] === 1 ? 'asc' : 'desc';
            this.getSuggestions();
        },
        getIndex(array, key, value) {
            return array.findIndex(i => i[key] == value)
        },
        getSearch: debounce(function (e) {
            this.changePerPage()
        }, 500),
        navigation(page) {
                this.tableData.page = page;
                axios.get(api('administration/suggestions'), {params: this.tableData})
                    .then(response => {
                        let content = response.data;
                        this.suggestions = content.data;
                        this.configPagination(content);
                    })
                    .catch(errors => {
                        console.log(errors);
                    });
        },
    }
}
</script>
<style lang="scss" scoped>
    .pointer{
        cursor: pointer;
    }
</style>
